import { render } from "./ApprovedDowngrade.vue?vue&type=template&id=1da04906"
import script from "./ApprovedDowngrade.vue?vue&type=script&lang=js"
export * from "./ApprovedDowngrade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__